import {Component, forwardRef} from "@angular/core";
import {SelectOptionsComponent} from "../../entity/select/options/select-options.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: "wbo-boolean-select-options",
    templateUrl: "./boolean-select-options.component.html",
    providers: [{
        provide: SelectOptionsComponent,
        useExisting: forwardRef(() => BooleanSelectOptionsComponent),
        multi: true
    }]
})
export class BooleanSelectOptionsComponent extends SelectOptionsComponent {
    constructor(translateService: TranslateService) {
        super(translateService);
    }
}
